// Generated by ReScript, PLEASE EDIT WITH CARE

import * as FieldsetLayoutPanelTsx from "./FieldsetLayoutPanel.tsx";

let make = FieldsetLayoutPanelTsx.FieldsetLayoutPanelSection;

let Section = {
  make: make
};

let make$1 = FieldsetLayoutPanelTsx.FieldsetLayoutPanel;

export {
  Section,
  make$1 as make,
}
/* make Not a pure module */
